export const FETCH_PACIENTES_REQUEST = "FETCH_PACIENTES_REQUEST";
export const FETCH_PACIENTES_SUCCESS = "FETCH_PACIENTES_SUCCESS";
export const FETCH_PACIENTES_FAILURE = "FETCH_PACIENTES_FAILURE";
export const UPDATE_PACIENTE_IN_ARRAY = "UPDATE_PACIENTE_IN_ARRAY";
export const ADD_PACIENTE_IN_ARRAY = "ADD_PACIENTE_IN_ARRAY";
